import React from 'react';
import PropTypes from 'prop-types';
import shortId from 'shortid';
import { get, startCase } from 'lodash';
import { Tabs, Tab } from 'react-bootstrap';
import DetailsPanel from 'components/DetailsPanel';
import styles from './styles.css';

// TODO: this filter may not be needed.
function filterTabs(child, isFirstPartyJournal) {
  if (child) {
    const { defaultMessage } = child.props.title.props;
    const isTravelRuleTab = defaultMessage === 'Travel Rule Details';
    if (isFirstPartyJournal && isTravelRuleTab) {
      return false;
    }
  }
  return child;
}

const TabbedDetailsPanel = ({ children, panelName, isFirstPartyJournal, offset }) => (
  <DetailsPanel offset={offset} mdSize={6}>
    <Tabs animation={false} id={panelName} className={styles.container}>
      {children
        .filter((c) => filterTabs(c, isFirstPartyJournal))
        .map((child, idx) => {
          const titleElement = get(child, 'props.title', idx);
          const capitalizeTitle = startCase(titleElement.props.defaultMessage);

          // Used for functional tests to be able to click tab links.
          const titleText = get(titleElement, 'props.defaultMessage', idx);
          return (
            <Tab title={capitalizeTitle} eventKey={titleText.replace(/ /g, '_')} key={shortId.generate()}>
              {child}
            </Tab>
          );
        })}
    </Tabs>
  </DetailsPanel>
);

TabbedDetailsPanel.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  panelName: PropTypes.string.isRequired,
  isFirstPartyJournal: PropTypes.bool.isRequired,
  offset: PropTypes.string,
};

TabbedDetailsPanel.defaultProps = {
  children: [],
  offset: null,
};

export default TabbedDetailsPanel;



// WEBPACK FOOTER //
// ./src/components/TabbedDetailsPanel/index.js